/*eslint-disable*/
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _instanceof(left, right) {
  if (right != null && typeof Symbol !== 'undefined' && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*eslint-disable*/

/*!
 * vidbg.js v2.0 (https://github.com/blakewilson/vidbg)
 * vidbg.js By Blake Wilson
 * @license Licensed Under MIT (https://github.com/blakewilson/vidbg/blob/master/LICENSE)
 */
//import convert from 'hex-rgb';

/**
 * The vidbg class. This will be the reference for the plugin.
 * For example: var videoBackground = new vidbg(selector, options, attributes)
 */


var vidbg = /*#__PURE__*/function () {
  /**
   * Setup our defualt options and config for our plugin.
   *
   * @param {String} selector The selector for the video background
   * @param {object} options The options for the plugin
   * @param {object} attributes The attributes for the HTML5 <video> attribute
   */
  function vidbg(selector, options, attributes) {
    var _this = this;

    _classCallCheck(this, vidbg);

    _defineProperty(this, 'createContainer', function () {
      _this.containerEl = document.createElement('div');
      _this.containerEl.className = 'vidbg-container';

      _this.createPoster();

      _this.el.appendChild(_this.containerEl);
    });

    _defineProperty(this, 'createOverlay', function () {
      _this.overlayEl = document.createElement('div');
      _this.overlayEl.className = 'vidbg-overlay';

      _this.containerEl.appendChild(_this.overlayEl);
    });

    _defineProperty(this, 'createPoster', function () {
      if (_this.options.poster) {
        _this.containerEl.style.backgroundImage = 'url('.concat(_this.options.poster, ')');
      }
    });

    _defineProperty(this, 'createVideo', function () {
      _this.videoEl = document.createElement('video'); // Set the MP4 source if one exists.

      if (_this.options.mp4) {
        var mp4Source = document.createElement('source');
        mp4Source.src = _this.options.mp4;
        mp4Source.type = 'video/mp4';

        _this.videoEl.appendChild(mp4Source);
      } // Set the WEBM source if one exists.


      if (_this.options.webm) {
        var webmSource = document.createElement('source');
        webmSource.src = _this.options.webm;
        webmSource.type = 'video/webm';

        _this.videoEl.appendChild(webmSource);
      }
      /**
       * Set the attributes for the <video> element.
       * It is important that these are added to the video element before the
       * play promise since autoplay primarily only works when the video is
       * muted.
       */


      console.log(_this.attributes);

      for (var key in _this.attributes) {
        _this.videoEl[key] = _this.attributes[key];
      } // The play promise


      var playPromise = _this.videoEl.play();
      /**
       * If the browser supports promises, we will use the play promise
       * to determine if autoplay is supported or not.
       *
       * If promises are supported, and autoplay is not supported, we will
       * remove the HTML5 <video> element and the fallback image will be used.
       */
      // if (playPromise !== undefined) {
      //     playPromise
      //         .then(function() {
      //             // Autoplay has started.
      //         })
      //         .catch(function(e) {
      //             console.error('Autoplay is not supported');
      //             _this.removeVideo();
      //         });
      // }


      _this.videoEl.addEventListener('playing', _this.onPlayEvent);

      _this.containerEl.appendChild(_this.videoEl);
    });

    _defineProperty(this, 'onPlayEvent', function (event) {
      // Resize the video on play
      _this.resize(); // Show the video


      _this.videoEl.style.opacity = 1;
    });

    _defineProperty(this, 'removeVideo', function () {
      _this.videoEl.remove();
    });

    _defineProperty(this, 'resize', function () {
      // Get the width and height of the container we created
      var containerWidth = _this.containerEl.offsetWidth;
      var containerHeight = _this.containerEl.offsetHeight; // Get the width and height of the HTML5 <video> element we created

      var videoWidth = _this.videoEl.videoWidth;
      var videoHeight = _this.videoEl.videoHeight;
      /**
       * Depending on the width and height of the browser, we will either set the video width
       * to the container's width and the height to auto, or the width to auto and the height
       * to the container's height.
       */

      if (containerWidth / videoWidth > containerHeight / videoHeight) {
        _this.videoEl.style.width = ''.concat(containerWidth, 'px');
        _this.videoEl.style.height = 'auto';
      } else {
        _this.videoEl.style.width = 'auto';
        _this.videoEl.style.height = ''.concat(containerHeight, 'px');
      }
    });

    if (!selector) {
      console.error('Please provide a selector');
      return false;
    } // The element


    this.el = document.querySelector(selector); // These are the default options for vidbg

    var defaultOptions = {
      mp4: null,
      webm: null,
      poster: null,
      overlay: false,
      overlayColor: '#000',
      overlayAlpha: 0.3
    }; // Use the spread operator to merge our default options with user supplied options.

    this.options = _objectSpread(_objectSpread({}, defaultOptions), options); // These are the default attributes for the HTML5 <video> element.

    var defaultAttributes = {
      autoplay: true,
      controls: false,
      loop: true,
      muted: true,
      playsInline: true
    }; // Use the spread operator to merge our default attributes with user supplied options.

    this.attributes = _objectSpread(_objectSpread({}, defaultAttributes), attributes);

    if (!this.options.mp4 && !this.options.webm) {
      console.error('Please provide an mp4, webm, or both.');
      return false;
    }

    this.init();
  }
  /**
   * init the video background to the DOM.
   */


  _createClass(vidbg, [{
    key: 'init',
    value: function init() {
      this.el.style.position = 'relative';
      this.el.style.zIndex = 1;
      this.createContainer();
      this.createVideo();
      this.createOverlay();
      window.addEventListener('resize', this.resize);
    }
    /**
     * Create the container element and append it to the selector.
     */

  }]);

  return vidbg;
}();

export default vidbg;